import { TaiLieu } from "./TaiLieu";

export class TrinhDoHocVan{
    "id": number;
    "idNhanVien": number;
    "idHocHam": number;
    "uuTien": boolean;
    "coSoDaoTao": string;
    "idChuyenNganhDaoTao": number;
    "idHinhThucDaoTao": number;
    "ngayBatDau": Date;
    "ngayKetThuc": Date;
    "idXepLoaiTotNghiep": number;
}

export class TrinhDoHocVanResponse{
    "id": number;
    "idNhanVien": number;
    "idHocHam": number;
    "tenHocHam": string;
    "uuTien": boolean;
    "coSoDaoTao": string;
    "idChuyenNganhDaoTao": number;
    "tenChuyenNganhDaoTao": string
    "idHinhThucDaoTao": number;
    "tenHinhThucDaoTao": string;
    "ngayBatDau": Date;
    "ngayKetThuc": Date;
    "idXepLoaiTotNghiep": number;
    "tenXepLoaiTotNghiep": string;
    "dsTaiLieu": Array<TaiLieu>;
}